var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#6f29a3",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.052 7.6095c-0.5207-0.52067-1.3649-0.52067-1.8856 0l-6.5165 6.523c-1.0406 1.0415-1.0402 2.7292 8e-4 3.7703l6.5205 6.5205c0.5207 0.5207 1.3649 0.5207 1.8856 0s0.5207-1.3649 0-1.8856l-5.5808-5.5809c-0.5208-0.5207-0.5208-1.3649 0-1.8856l5.576-5.5761c0.5207-0.52067 0.5207-1.3648 0-1.8856z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeft);
export default __webpack_public_path__ + "static/media/icon_arrow-left.e87874f62da3a807f2a8da51bf28e237.svg";
export { ForwardRef as ReactComponent };